import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { PerplayLogApi, LogControllerDtoLevelUpLogListRequest } from '../../models/src';
import {
  levelUpLogList,
  setLevelUpLogPagination,
  setTotalCount
} from '../../actions/log/levelUpLogActions';
import { LEVELUPLOG_LIST_REQUEST } from '../../constants/log/levelUpLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoLevelUpLogListResponse from '../../models/src/model/LogControllerDtoLevelUpLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* levelUpLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoLevelUpLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogLevelUpLogListPost({ logControllerDtoLevelUpLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoLevelUpLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(levelUpLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(setLevelUpLogPagination(
      payload.page,
      data.totalCount,
      payload.beginDate,
      payload.endDate,
      payload.searchCode,
      payload.searchString,
    ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* levelUpLogRootSaga() {
  yield all([
    takeEvery(LEVELUPLOG_LIST_REQUEST, levelUpLogListRequestSaga),
  ])
}

const levelUpLogSagas = [
  fork(levelUpLogRootSaga),
];

export default levelUpLogSagas;
